"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVRN = validateVRN;
exports.handleVRNInput = handleVRNInput;
exports.removeAdditionalDriver = removeAdditionalDriver;
exports.getVehiclesAdditionalDrivers = getVehiclesAdditionalDrivers;
exports.isDriverNameValid = isDriverNameValid;
exports.renderVehicleDrivers = renderVehicleDrivers;
exports.isDriverNameAppropriateForLicenceNumber = isDriverNameAppropriateForLicenceNumber;
exports.driverNamesAreValid = driverNamesAreValid;
var jsx_runtime_1 = require("react/jsx-runtime");
var journey_services_1 = require("@ferry/journey-services");
var drivingLicenceHelper_1 = require("../drivingLicenceHelper");
function validateVRN(vrn) {
    return journey_services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn);
}
function handleVRNInput(event, setState, onStateChange) {
    return __awaiter(this, void 0, void 0, function () {
        var vrn, isValid, targetKey;
        return __generator(this, function (_a) {
            vrn = event.target.value.trim().toUpperCase();
            isValid = validateVRN(vrn);
            setState(function (prev) { return (__assign(__assign({}, prev), { vrn: vrn, isVRNValid: isValid })); });
            targetKey = "vehicles[0].registrationNumber";
            onStateChange(targetKey, isValid ? vrn : null);
            return [2 /*return*/];
        });
    });
}
function removeAdditionalDriver(interaction, driverPersonId, vehicleIndex) {
    var vehicle = interaction.vehicles[vehicleIndex];
    var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(String(driverPersonId)) === 0; });
    if (driverIdIndex > -1) {
        vehicle.driverIds.splice(driverIdIndex, 1);
    }
    var additionalDrivers = interaction.additionalDrivers;
    var driverIndex = additionalDrivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
    if (driverIndex > -1) {
        additionalDrivers.splice(driverIndex, 1);
    }
    // if main driver is deleted and new main driver is not set, Polaris will fail to process such interaction
    if (vehicle.mainDriverId === driverPersonId) {
        vehicle.mainDriverId = interaction.policyHolder.personId;
    }
    vehicle.numberOfDrivers -= 1;
    return vehicle;
}
function getVehiclesAdditionalDrivers(interaction) {
    var vehicleDrivers = new Set();
    interaction.vehicles.forEach(function (vehicle) {
        vehicle.driverIds.forEach(function (driverId) {
            var driver = interaction.additionalDrivers.find(function (driver) { return driverId === driver.personId && interaction.policyHolder.personId !== driver.personId; });
            if (driver) {
                vehicleDrivers.add(driver);
            }
        });
    });
    return Array.from(vehicleDrivers);
}
function isDriverNameValid(name) {
    var expression = /^[a-z ,.'-]+$/i;
    return expression.test(name);
}
function renderVehicleDrivers(interaction, vehicle, renderCallback) {
    var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
    var vehicleDrivers = [];
    if (vehicle.driverIds) {
        vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); })
            .filter(function (driver) { return driver !== undefined; });
    }
    if (renderCallback) {
        return renderCallback(vehicleDrivers);
    }
    else {
        return vehicleDrivers.map(function (driver) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "driver", children: ["".concat(driver.firstName, " ").concat(driver.lastName), " ", driver.personId === vehicle.mainDriverId &&
                        (0, jsx_runtime_1.jsx)("span", { children: "(main driver)" })] }, driver.personId));
        });
    }
}
function isDriverNameAppropriateForLicenceNumber(driver) {
    var _a;
    var regex = /\s/;
    if (((_a = driver.licence) === null || _a === void 0 ? void 0 : _a.number) == null) {
        return true;
    }
    var trimmedLicence = driver.licence.number.replace(regex, '');
    return drivingLicenceHelper_1.default.validateFirstNameSection(driver.firstName, trimmedLicence.substring(11, 13).toUpperCase()) &&
        drivingLicenceHelper_1.default.validateLastNameSection(driver.lastName, trimmedLicence.substring(0, 5).toUpperCase());
}
function driverNamesAreValid(policyHolder, additionalDrivers) {
    var hasInvalidPolicyHolderName = !(isDriverNameValid(policyHolder.firstName) &&
        isDriverNameValid(policyHolder.lastName) &&
        isDriverNameAppropriateForLicenceNumber(policyHolder));
    var hasInvalidAdditionalDriverNames = !additionalDrivers || additionalDrivers.length == 0 ?
        false : !additionalDrivers.every(function (element) {
        return isDriverNameValid(element.firstName) && isDriverNameValid(element.lastName) && isDriverNameAppropriateForLicenceNumber(element);
    });
    return !hasInvalidPolicyHolderName && !hasInvalidAdditionalDriverNames;
}
//# sourceMappingURL=QuoteSummaryPanelUtils.js.map